<template>
    <BaseLayout>  
        <TitleModel
            :title="'招聘合作'"
            :content="'Tao家面向全球长期诚聘 MM，最优待遇业界顶薪，'"
            :content1="'并期待与各位同行友人、经济公司合作。'"
        />  
        
        <PContentModel>
          <P v-html="hzHtmlStr"></P>
        </PContentModel> 

        
        <TitleModel
            :title="'量身定制工作计划'" 
        />  
        <PContentModel>
          <P v-html="dztmlStr"></P>
        </PContentModel>  

    </BaseLayout>
</template>

<script>
import BaseLayout from '../components/BaseLayout.vue'
import TitleModel from '../components/TitleModel.vue'
import PContentModel from '../components/PContentModel.vue'
export default {
  name: 'VipPage',
  components: {
    BaseLayout,
    TitleModel,
    PContentModel
  },
  data() {
    return {
      showModal: false,
      hzHtmlStr:"招聘合作内容",
      dztmlStr:"量身订制内容",

    }
  },
  created() {
   let  _blocks = this.$store.state.baseInfo.block 
   let baseInfoJson = this.$local.getItem('baseInfoJson');  
   if(baseInfoJson){
    let baseInfo = JSON.parse(baseInfoJson);
    _blocks = baseInfo.block;
   }

   _blocks = _blocks.filter(item => item.status === "5");
   if(_blocks.length > 1){
    this.hzHtmlStr = _blocks[0].content;
    this.dztmlStr = _blocks[1].content;
   } 
  //  console.log('---合作-block',_blocks);
  },
  methods:{
    filterBlock(label) {
      // 查找对应的item
      return this.contactList.find(item => item.status === label);
    },
  }
}
</script>

<style scoped>
@media screen and (max-width: 767px)and (min-width: 0px){
  .vip-p{
    width: 100% !important;
  }

}
@media screen and (min-width: 767px) and (max-width: 1199px){
  
 
}
.pt-align{
    text-align: center !important ;
}
.pt-pmzeno{ 
    margin: 0;
    padding: 0;
}  
.vip-p{
  width: 70%;
  margin: auto;
}
</style>